<template>
    <div>
        <div class="tfs4jira-mapping-layout">
            <div class="tfs4jira-mapping-layout-row">
                <div class="tfs4jira-mapping-layout-column-jira">
                    <h2>{{jiraSelectTitle}}</h2>
                    <div class="tfs4jira-mapping-header-note-jira"></div>
                </div>
                <div class="tfs4jira-mapping-layout-column-tfs">
                    <h2>{{tfsSelectTitle}}</h2>
                    <div class="tfs4jira-mapping-header-note-tfs"></div>
                </div>
            </div>
            <div class="tfs4jira-mapping-layout-row">
                <div class="tfs4jira-mapping-layout-column-jira">
                    <select id="jiraValuesSelect" class="tfs4jira-mapping-select" size="10" v-model="selectedJiraValue">
                        <option v-for="value in jiraValues" :key="value.key" :value="value">
                            {{value.label}}
                        </option>
                    </select>
                </div>
                <div class="tfs4jira-mapping-layout-column-tfs">
                    <select id="tfsValuesSelect" class="tfs4jira-mapping-select" size="10" v-model="selectedTfsValue">
                        <option v-for="value in tfsValues" :key="value.key" :value="value">
                            {{value.label}}
                        </option>
                    </select>
                </div>
            </div>        
        </div>
        <button @click="addMapping()" 
                :disabled="isMapButtonDisabled()" 
                class="tfs4jira-mapping-map-button tfs4jira-rounded-button" title="Please select values for both Jira and TFS to map them.">Map
        </button>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import { NAMESPACE as MAPPINGS_NAMESPACE } from '../../store/modules/mappings.js';

    export default {
        props: {
            jiraSelectTitle: String, 
            tfsSelectTitle: String
        },
        data() {
            return {
                 selectedTfsValue: null,
                 selectedJiraValue: null
            }
        },
        computed: mapGetters({
            jiraValues: MAPPINGS_NAMESPACE.getters.JIRA_VALUES,
            tfsValues: MAPPINGS_NAMESPACE.getters.TFS_VALUES
        }),
        methods: {
            ...mapActions({
                mapValues: MAPPINGS_NAMESPACE.actions.MAP,
            }),
            addMapping: function() {
                if (this.selectedJiraValue !== null && this.selectedTfsValue !== null) {
                    let pair = {
                        jiraValue: this.selectedJiraValue,
                        tfsValue: this.selectedTfsValue
                    };
                    this.mapValues(pair);
                    this.selectedTfsValue = null;
                    this.selectedJiraValue = null;
                }
            },
            isMapButtonDisabled: function() {
                return this.selectedJiraValue === null || this.selectedTfsValue === null;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/mappings/MappingSelects.vue